import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const isVoucherLoading = createSelector(onlineOrderState, (onlineOrder) => onlineOrder.voucherRequest.isVoucherAdding);
